import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "p-4"
};
const _hoisted_2 = {
  class: "-mx-4"
};
const _hoisted_3 = {
  class: "max-w-[30rem] w-full"
};
const _hoisted_4 = {
  class: "fle flex-col"
};
const _hoisted_5 = {
  key: 0,
  class: "font-bold mr-4"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
import Modal from "@/modules/vue/components/Modal.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Promotions',
  props: {
    promotions: null
  },
  setup(__props) {
    const props = __props;
    const showPopover = ref(false);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => _ctx.$refs.modal.show(), ["prevent"]))
      }, _toDisplayString(_ctx.$t('show_promotions_and_delegation_rules')), 1), _createVNode(Modal, {
        ref: "modal"
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('promotions')), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.promotions, promotion => {
          return _openBlock(), _createElementBlock("div", {
            key: promotion.id,
            class: "p-2 border-b last:border-b-0"
          }, [_createElementVNode("div", _hoisted_4, [promotion.rank_form && promotion.rank_to ? (_openBlock(), _createElementBlock("div", _hoisted_5, [promotion.rank_form === promotion.rank_to ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('x_rank', {
            rank: promotion.rank_to
          })), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('from_to_rank', {
            from: promotion.rank_form,
            to: promotion.rank_to
          })), 1))])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("ul", null, [promotion.target_division ? (_openBlock(), _createElementBlock("li", _hoisted_8, _toDisplayString(_ctx.$t('transfer_to_x', {
            name: promotion.target_division.name
          })), 1)) : _createCommentVNode("", true), promotion.price > 0 ? (_openBlock(), _createElementBlock("li", _hoisted_9, _toDisplayString(_ctx.$t('x_price_money', {
            price: _ctx.$money(promotion.price)
          })), 1)) : _createCommentVNode("", true)])])])]);
        }), 128))])])]),
        _: 1
      }, 512)]);
    };
  }
});